module.exports = __webpack_public_path__ + "static/gallery31-28410799e9a32d1f1bb9b6c938dcb765.jpg";